import React from 'react';
import { useParams, Link } from 'react-router-dom';

const DOCS = {
  cgu: {
    title: "Conditions Générales d'Utilisation",
    file: '/cgu.pdf',
  },
  confidentialite: {
    title: 'Politique de confidentialité',
    file: '/politique-confidentialite.pdf',
  },
};

export default function PdfViewerPage() {
  const { doc } = useParams();
  const entry = DOCS[doc];

  return (
    <div className="min-h-screen flex flex-col bg-slate-50">
      {/* Header */}
      <header className="bg-white border-b border-slate-200 px-6 py-4 flex items-center gap-4 shrink-0">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 rounded bg-primary flex items-center justify-center overflow-hidden">
            <img
              src="/mfb-logo.png"
              alt="MFB"
              className="w-10 h-6 object-contain"
              onError={(e) => {
                e.currentTarget.style.display = 'none';
                e.currentTarget.parentElement.innerHTML =
                  '<span class="text-white font-black text-[10px]">MFB</span>';
              }}
            />
          </div>
          <span className="text-[13px] font-semibold text-slate-700">Maroc Fruit Board</span>
        </div>
        <span className="text-slate-300">|</span>
        <h1 className="text-[13px] font-medium text-slate-600">
          {entry ? entry.title : 'Document introuvable'}
        </h1>
        <div className="ml-auto">
          <Link
            to="/login"
            className="text-[12px] text-primary hover:underline"
          >
            ← Retour à la connexion
          </Link>
        </div>
      </header>

      {/* Body */}
      <main className="flex-1 flex flex-col p-6">
        {!entry ? (
          <div className="flex-1 flex items-center justify-center">
            <p className="text-slate-500 text-sm">Document non trouvé.</p>
          </div>
        ) : (
          <div className="flex-1 bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden">
            <iframe
              src={entry.file}
              title={entry.title}
              className="w-full h-full min-h-[80vh]"
              style={{ border: 'none' }}
            />
          </div>
        )}
      </main>

      <footer className="text-center text-[11px] text-slate-400 py-3">
        © 2026 MFB Fresh Logistics
      </footer>
    </div>
  );
}
